<template>
  <div class="w-100 h-100">
    <b-container fluid>
      <h2 class="tw-mb-0 text-aegis-dk">
        Open AE/SAE > 10 Days
      </h2>
      <p class="tw-italic tw-text-gray-700">
        <!-- flavor text! -->
      </p>
    </b-container>

    <!-- I DON'T THINK THIS SEARCH IS DOING ANYTHING. MATT SAID TO REMOVE IT. -->
    <!-- I THOUGHT I'd LEAVE IT HERE FOR TROUBLESHOOTING LATER -->
    <!-- <b-container fluid>
      <b-row>
      <b-col lg="4"></b-col>
      <b-col lg="4"></b-col>
      <b-col lg="4">
        <b-form-group
          label=""
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          label-for="filterInput"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              v-model="filter"
              type="search"
              id="filterInput"
              placeholder="Type to Search"
            ></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
        <br />
      </b-col>
    </b-row>
    </b-container> -->

    <hr>

    <small>
      Total Results: {{ totalRows }} 
      <i @click="downloadFile"
        class="fa fa-download text-success"
        v-b-modal.report-modal style="margin-left: 10px;
        cursor: pointer;"
        title="Download All"
      ></i>
    </small>
    
    <b-card no-body>
        <b-tabs card fill>
          <b-tab :title="'AE/SAE Cases'" active>
            <b-card-text >
              <b-table
                striped
                hover
                :fields="fields"
                :items="find"
                :filter="filter"
                :tbody-tr-class="'clickable'"
                @row-clicked="rowClicked"
              ></b-table>
            </b-card-text>
          </b-tab>
        </b-tabs>
    </b-card>
    
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

import { mapActions } from "vuex";

export default {
  mixins: [DashboardBaseTemplate],
  data: function() {
    return {
      fields: [
        // { key: "subject_id", label: "Subject ID" },
        // { key: "ae_sae_id", label: "Malaria AE/SAE ID" },
        // { key: "date_of_collection", label: "Bloodslide Collected Date" },
        // { key: "ae_sae_date", label: "Malaria Diagnosis Date" },
      ],
      totalRows: 0,
      currentPage: 1,
      perPage: 20,
      perPageOptions: [
        10,
        15,
        20,
        25,
        50
      ],
      items: [],
      componentKey: 0,
      filter: null,
      active_aesae_list: [],
      active_aesae_modal_title: 'AE/SAE Cases',
      selected_subject: null
    };
  },
  computed: {},
  mounted: function() {},
  methods: {
     ...mapActions('adverseevents', 
            ['getTenDayAESAECount', 'setTenDayAESAECount']),

    refreshSideNavCount(){
      this.getTenDayAESAECount().then((response) => {
                this.setTenDayAESAECount(response.data);
            });
    },

    // refreshSideNavCount(){
    //   this.getSubjectsReferredCount().then((response) => {
    //             this.setSubjectsReferredCount(response.data);
    //         })
    // },
    // view_aesae_list: function(index){
    //   let that = this;
    //   that.active_aesae_list = that.subjects[index].aesae_list;
    //   that.active_aesae_modal_title = 'AE/SAE Cases for ' + that.subjects[index].subject_id;
    // },

    find: function(ctx) {
      let that = this;
      let params = {
        current_page: ctx.currentPage,
        per_page: ctx.perPage,
        sort_by: ctx.sortBy,
        sort_desc: ctx.sortDesc
      }

      if(that.filterDate && that.filterDate != ''){
        params.filterDate = that.filterDate;
      }
      if(that.filterCompound != 'All'){
        params.filterCompound = that.filterCompound;
      }
      if(that.filterVisitTime != 'All'){
        params.filterVisitTime = that.filterVisitTime;
      }

      return HTTP.get("/kenya/ten-day-open-aesae-table/", {
        params: params
      })
        .then((response) => {
          that.tableData = response.data.items;
          that.totalRows = response.data.totalRows;
          return that.tableData;
        })
        .catch((error) => {
          HandleErrors.HandleErrors(error);
        });
    },
    downloadFile: function(){
      var params = new URLSearchParams();
      params.append("return_as", "csv");

      HTTP.get("/kenya/ten-day-open-aesae-table/", {params: params}).then(response => {
        var fileURL = window.URL.createObjectURL(
          new Blob([response.data])
        );
        var fileLink = document.createElement("a");
        fileLink.href = fileURL;
        // const today = new Date();
        // fileLink.setAttribute("download", "DataExport-" + today + ".csv");
        fileLink.setAttribute("download", "DataExport.csv");
        document.body.appendChild(fileLink);
        fileLink.click();
      });
    },

    rowClicked(record, index){
      let that = this;
      that.selected_subject = record;
    },

    showModal() {
        this.$refs[('contact_info_modal')].show();
      },
    // dismiss: function(index){
    //   let that = this;
    //   HTTP.post("/kenya/subjects_referred/"+that.subjects[index].id+"/", {
    //     status: 'dismiss'
    //   }).then(() => {
    //       var dismissed_obj = that.subjects.splice(index, 1)[0];
    //       that.dismissed_subjects.push(dismissed_obj);
    //       that.refreshSideNavCount();
    //   });


    // }
  }
};
</script>

<style>
.right-text{
  text-align: right;
}
.clickable {
  cursor: pointer;
}
</style>